import React, { Component } from "react";

const PortfolioListContent = [
  {
    image: "image-1",
    category: "React JS,Express, Node.js, MongoDB",
    title: "Bus Booking App(Bookbus)",
    link: "https://bookbus.herokuapp.com",
    repo: "https://github.com/Solomonyakubu/campus-bus-booking",
    info: "A bus booking app that makes it easy to book buses on campus by generating a QRcode scannable ticket",
  },
  {
    image: "image-2",
    category: "React JS, Express, Node.js, MongoDB",
    title: "Link Shortener(Lincut)",
    link: "https://lincut.vercel.app",
    repo: "https://github.com/Solomonyakubu/url-shortener",
    info: "A url shortener that shortens long links and keep track of clicks",
  },
  {
    image: "image-3",
    category: "React JS, Express, Node.js, MongoDB",
    title: "Quiz App(Quiz Ninja)",
    link: "https://quizninja.netlify.app",
    repo: "https://github.com/Solomonyakubu/quizzify",
    info: "A Quiz App with different modes",
  },
  {
    image: "image-4",
    category: "Node.js",
    title: "Twitter Bot(Funbot)",
    link: "https://www.twitter.com/_funbot",
    info: "A twitter bot with 2000+ followers that post and retweet coding related contents",
  },
];

class PortfolioList extends Component {
  render() {
    const { column, styevariation } = this.props;
    const list = PortfolioListContent.slice(0, this.props.item);
    return (
      <React.Fragment>
        {list.map((value, index) => (
          <div className={`${column}`} key={index}>
            <div className={`portfolio ${styevariation}`}>
              <div className="thumbnail-inner">
                <div className={`thumbnail ${value.image}`}></div>
                <div className={`bg-blr-image ${value.image}`}></div>
              </div>
              <div className="content">
                <div className="inner">
                  <p>{value.category}</p>
                  <h4>
                    <a href={value.link} rel="noreferrer" target="_blank">
                      {value.title}
                    </a>
                    <div
                      style={{
                        fontSize: "12px",
                        lineHeight: "normal",
                        color: "rgb(219, 219, 219)",
                      }}
                    >
                      {value.info}
                    </div>
                  </h4>
                  <div className="postButtons">
                    {value.link ? (
                      <div className="portfolio-button">
                        <a
                          className="rn-btn"
                          href={value.link}
                          rel="noreferrer"
                          target="_blank"
                        >
                          Live
                        </a>
                      </div>
                    ) : null}
                    {value.repo ? (
                      <div className="portfolio-button">
                        <a
                          className="rn-btn"
                          href={value.repo}
                          rel="noreferrer"
                          target="_blank"
                        >
                          Repo
                        </a>
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </React.Fragment>
    );
  }
}
export default PortfolioList;
